<div
  class="language-item"
  (click)="openLangPortal()"
  tabindex="0"
  (keydown.enter)="openLangPortal()"
>
  <div class="language-content">
    <img
      class="flag-icon"
      [src]="getFlagIconPath(selectedLanguageObject()?.code)"
      [alt]="selectedLanguageObject()?.name"
    />
    <span>{{ selectedLanguageObject()?.name }}</span>
    <mat-icon class="arrow-icon">
      {{ isLanguageDropdownOpen() ? "keyboard_arrow_left" : "keyboard_arrow_right" }}
    </mat-icon>
  </div>
</div>

<!-- Modal -->

<ng-template cdkPortal #langPortal>
  @if (isLanguageDropdownOpen()) {
    <app-select-modal
      [title]="'shared.profile_dropdown.change_language' | translate"
      [options]="options()"
      [selected]="chosenLanguage() ?? selectedLanguage()"
      [labelFn]="getLabel"
      [mobile]="isMobile()"
      (optionSelect)="selectLanguage($event)"
      (cancelClick)="cancelLanguageSelection()"
      (saveClick)="saveLanguage()"
      (backdropClick)="closeLanguageModal()"
      (modalClose)="closeLanguageModal()"
    />
  }
</ng-template>
